<template>
  <div>
    <v-app-bar
      flat
      color="transparent"
      class="main-appbar"
    >
      <app-bar-nav-icon />
      <div class="d-flex align-center">
        <v-toolbar-title>
          <h1 class="headline font-weight-bold">Articles</h1>
        </v-toolbar-title>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex flex-row">
        <v-row
          v-if="showSearch"
          align="center"
          style="width: 300px;"
        >
          <v-text-field
            flat
            hide-details
            single-line
            label="Search by article title or author"
            v-model="filter.search"
            @input="search"
          ></v-text-field>
        </v-row>
        <v-btn
          class="ml-5"
          icon
          @click="showSearch = !showSearch"
        >
          <img
            src="@/assets/icons/search.svg"
            alt
          />
        </v-btn>
      </div>

      <v-btn
        color="primary"
        dark
        class="ml-4"
        :to="{name: 'articles.create'}"
      >
        <v-icon class="mr-2 body-1">mdi-pencil</v-icon>
        <span style="text-transform: none">Create New</span>
      </v-btn>
    </v-app-bar>

    <article-details
      @refreshArticleList="fetchArticles"
      @closeArticleDetails="viewArticle = false"
      :viewArticle="viewArticle"
      :recordId="articleId"
      @clearSelectedArticle="articleId = 0"
    ></article-details>

    <v-card flat>
      <div class="d-flex flex-row justify-space-between px-4">
        <div class="article-filters d-flex flex-row">
          <v-select
            outlined
            dense
            v-model="article_filter"
            label="Articles"
            :items="article_filters"
            width="220px"
            @change="filterArticles"
          ></v-select>

          <v-select
            class="ml-3"
            outlined
            dense
            v-model="sport_filter"
            label="Sport"
            width="100px"
            :items="sports"
            @change="filterArticles"
          ></v-select>

          <v-select
            class="ml-3"
            outlined
            dense
            v-model="article_category_filter"
            label="Source"
            width="100px"
            :items="article_categories"
            @change="filterArticles"
          ></v-select>

          <author-selector-auto-complete
            class="ml-3"
            :isDense="true"
            :isChips="false"
            :isMultiple="false"
            v-model="authorFilter"
            @change="filterArticles"
            componentLabel="Author"
          />

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                v-bind="attrs"
                v-on="on"
                class="ml-3"
                @click="resetFilter"
              >
                <v-icon
                  small
                  dark
                >mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>Reset filter</span>
          </v-tooltip>
        </div>

        <v-chip>Total: {{ listMeta.total | formatNumber }}</v-chip>
      </div>

      <div
        class="pa-4"
        id="article-list"
      >
        <v-simple-table>
          <thead>
            <tr>
              <th
                class="text-center"
                width="15%"
              >ICYMI Order</th>
              <th
                class="text-center"
                width="15%"
              >Featured Order</th>
              <th @click="sortTable('title')">
                <div class="d-flex justify-center justify-space-between">
                  Title
                  <v-icon
                    small
                    color="blue darken-2"
                    v-if="tableSort.sortBy === 'title'"
                  >{{ tableSort.icon }}</v-icon>
                  <v-icon
                    small
                    color="blue darken-2"
                    v-else
                  >mdi-sort</v-icon>
                </div>
              </th>
              <th
                class="text-left"
              >Author
              </th>
              <th class="text-left">Sport</th>
              <th class="text-left">Tags</th>
              <th
                class="text-left"
                @click="sortTable('created_at')"
              >
                <div class="d-flex justify-center justify-space-between">
                  Added Date
                  <v-icon
                    small
                    color="blue darken-2"
                    v-if="tableSort.sortBy === 'created_at'"
                  >{{ tableSort.icon }}</v-icon>
                  <v-icon
                    small
                    color="blue darken-2"
                    v-else
                  >mdi-sort</v-icon>
                </div>
              </th>
              <th>Photo</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(article, index) in articles"
              :key="article.id"
            >
              <td class="text-center">
                <div v-if="!article.unpublished_at && article.published_date">
                  <template v-for="moreIndex in moreOrderIndex">
                    <v-tooltip
                      left
                      :key="moreIndex"
                      v-if="article.more_order_index !== null && article.more_order_index >= moreIndex"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="yellow darken-2"
                          @click="setAsMoreOrderIndex(article.id, moreIndex)"
                        >mdi-star</v-icon>
                      </template>
                      <span>Order {{ moreIndex }}</span>
                    </v-tooltip>

                    <v-tooltip
                      v-else
                      left
                      :key="moreIndex"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="grey lighten-2"
                          @click="setAsMoreOrderIndex(article.id, moreIndex)"
                        >mdi-star</v-icon>
                      </template>
                      <span>Order {{ moreIndex }}</span>
                    </v-tooltip>
                  </template>
                </div>

                <div v-else>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="red darken-2"
                      >mdi-cancel</v-icon>
                    </template>
                    <span>Unpublished Article</span>
                  </v-tooltip>
                </div>
              </td>

              <td class="text-center">
                <div v-if="!article.unpublished_at && article.published_date">
                  <template v-for="featuredIndex in subFeaturesIndex">
                    <v-tooltip
                      left
                      :key="featuredIndex"
                      v-if="article.featured_article !== null && article.featured_article.order_index >= featuredIndex"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="yellow darken-2"
                          @click="setAsFeaturedArticle(article.id, featuredIndex)"
                        >mdi-star</v-icon>
                      </template>
                      <span v-if="featuredIndex == 1">Main Feature</span>
                      <span v-else>Sub Feature {{ featuredIndex }}</span>
                    </v-tooltip>

                    <v-tooltip
                      left
                      :key="featuredIndex"
                      v-else
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="grey lighten-2"
                          @click="setAsFeaturedArticle(article.id, featuredIndex)"
                        >mdi-star</v-icon>
                      </template>
                      <span v-if="featuredIndex == 1">Main Feature</span>
                      <span v-else>Sub Feature {{ featuredIndex }}</span>
                    </v-tooltip>
                  </template>
                </div>

                <div v-else>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="red darken-2"
                      >mdi-cancel</v-icon>
                    </template>
                    <span>Unpublished Article</span>
                  </v-tooltip>
                </div>
              </td>

              <td @click="viewArticleDetails(article.id)">
                <text-highlight :queries="filter.search">{{ article.title }}</text-highlight>
              </td>

              <td v-if="article.authors[0]" @click="viewArticleDetails(article.id)"> <span v-for="(author, authorIndex) in article.authors" :key="author.id">{{ getAuthorName(author) }}<span v-if="article.authors.length !== authorIndex +1">, </span></span></td>
              <td v-else @click="viewArticleDetails(article.id)">{{ article.author }}</td>

              <td
                @click="viewArticleDetails(article.id)"
                class="capitalize"
              >
                <span
                  :key="sport+index"
                  v-for="(sport, index) in uniq(map(article.tags, (tag) => {return capitalize(tag.type)}))"
                >{{ sport }} <span v-if="uniq(map(article.tags, (tag) => {return capitalize(tag.type)})).length > index + 1">, </span></span>
              </td>

              <td @click="viewArticleDetails(article.id)">
                <v-chip
                  :key="tag.id"
                  v-for="tag in article.tags"
                  class="ma-2"
                >{{ tag.name }}</v-chip>
              </td>

              <td @click="viewArticleDetails(article.id)">{{ article.addedDate }}</td>
              <td class="text-center py-4">
                <v-card
                  class="d-flex justify-space-between pa-2"
                  max-width="100"
                >
                  <div>
                    <user-avatar
                      :tile="true"
                      :avatar="article.thumbnail"
                      size="60"
                    />
                  </div>

                  <div class="d-inline-block pl-2">
                    <v-tooltip
                      left
                      v-if="article.is_trending === true"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="blue darken-2"
                          small
                        >mdi-trending-up</v-icon>
                      </template>
                      <span>Trending</span>
                    </v-tooltip>

                    <v-tooltip
                      left
                      v-if="article.featured_article !== null"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="yellow darken-2"
                          small
                        >mdi-star</v-icon>
                      </template>
                      <span v-if="article.featured_article.feature_type == 'main'">Main Feature</span>
                      <span v-else>
                        Sub Feature
                        {{ article.featured_article.order_index }}
                      </span>
                    </v-tooltip>
                    <v-tooltip
                      left
                      v-if="article.published_date && !article.unpublished_at"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="success darken-2"
                          small
                        >mdi-book-open-variant</v-icon>
                      </template>
                      <span>{{ article.publishedDate }}</span>
                    </v-tooltip>
                  </div>
                </v-card>
              </td>
              <td class="text-center">
                <v-menu
                  transition="slide-x-transition"
                  bottom
                  right
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="hoverable"
                      v-bind="attrs"
                      v-on="on"
                    >mdi-dots-vertical</v-icon>
                  </template>
                  <v-list>
                    <v-list-item @click="confirmDeleModal(article.id, index)">
                      <v-list-item-title>
                        <v-icon>mdi-delete</v-icon>Delete
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="editArticle(article.id)">
                      <v-list-item-title>
                        <v-icon>mdi-pencil</v-icon>Edit
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="previewArticle(article)">
                      <v-list-item-title>
                        <v-icon>mdi-eye</v-icon>View
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="article.published_date && !article.unpublished_at"
                      @click="triggerUnpublishArticle(article.id)"
                    >
                      <v-list-item-title>
                        <v-icon>mdi-file-remove</v-icon>Unpublish
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-else
                      @click="triggerPublishArticle(article.id)"
                    >
                      <v-list-item-title>
                        <v-icon>mdi-book</v-icon>Publish
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="triggerCloneArticle(article.id)">
                      <v-list-item-title>
                        <v-icon>mdi-content-copy</v-icon>Duplicate
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <div
          v-if="listMeta.total"
          class="py-5 d-flex justify-center"
        >
          <small class="grey--text lighten-4">
            {{ listMeta.from }}-{{ listMeta.to }} of
            {{ listMeta.total | formatNumber }}
          </small>
        </div>

        <v-overlay
          absolute
          :value="loading"
          :z-index="3"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
          ></v-progress-circular>
        </v-overlay>
      </div>
    </v-card>

    <div
      class="text-center mt-2 mb-8"
      v-if="listMeta.last_page > 1"
    >
      <v-pagination
        @input="pageChanged"
        :value="listMeta.current_page"
        :length="listMeta.last_page"
        :total-visible="10"
        circle
      ></v-pagination>
    </div>

    <v-overlay
      absolute
      :value="deleting_article"
      :z-index="3"
    >
      <v-dialog
        v-model="deleting_article"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            Deleting Article . .
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>

    <v-snackbar
      v-model="snackbar.show"
      right
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn
        text
        @click="snackbar.show = false"
      >OK</v-btn>
    </v-snackbar>

    <v-dialog
      v-model="confirmDeleteDialog"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          <p class="confirm-delete">Are you sure you want to delete this record?</p>
        </v-card-title>
        <v-card-text>Delete Article.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="confirmDeleteDialog = false"
          >No</v-btn>
          <v-btn
            color="red darken-1 white--text"
            @click="removeArticle()"
          >Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import head from 'lodash/head'
import get from 'lodash/get'
import map from 'lodash/map'
import uniq from 'lodash/uniq'
import capitalize from 'lodash/capitalize'
import { mapState, mapActions, mapMutations } from 'vuex'
import {
  mdiDotsVertical,
  mdiUnfoldMoreHorizontal,
  mdiMagnify,
  mdiAccountCircleOutline,
  mdiChevronRight
} from '@mdi/js'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import debounce from 'lodash/debounce'
import TextHighlight from 'vue-text-highlight'
import CreateArticle from '@/components/modals/article/CreateArticle'
import ArticleDetails from '@/components/modals/article/ArticleDetails'
import UserAvatar from '@/components/UserAvatar'
import AuthorSelectorAutoComplete from '@/views/Home/Articles/shared/AuthorSelectorAutoComplete'

export default {
  name: 'ArticlesPage',

  components: {
    AppBarNavIcon,
    TextHighlight,
    CreateArticle,
    UserAvatar,
    ArticleDetails,
    AuthorSelectorAutoComplete
  },

  data () {
    return {
      loading: false,
      showSearch: false,
      showProfile: false,
      selectedProfile: null,
      filter: {
        search: ''
      },
      subFeaturesIndex: [1, 2, 3, 4, 5, 6, 7],
      moreOrderIndex: [1, 2, 3, 4, 5, 6, 7],
      icons: {
        settings: mdiDotsVertical,
        sort: mdiUnfoldMoreHorizontal,
        search: mdiMagnify,
        view: mdiAccountCircleOutline,
        arrow: mdiChevronRight
      },
      article_filters: [
        {
          text: 'All',
          value: 'all'
        },
        {
          text: 'Featured',
          value: 'is_featured'
        },
        {
          text: 'Trending',
          value: 'is_trending'
        }
      ],
      article_filter: 'all',
      viewArticle: false,
      articleId: 0,
      deleting_article: false,
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      confirmDeleteDialog: false,
      confirmFeatureId: '',
      confirmFeatureIndex: '',
      toBeDeleted: {
        id: '',
        index: ''
      },
      sports: [
        {
          text: 'All',
          value: 'all'
        },
        {
          text: 'Baseball',
          value: 'baseball'
        },
        {
          text: 'Basketball',
          value: 'basketball'
        },
        {
          text: 'Football',
          value: 'football'
        },
        {
          text: 'Golf',
          value: 'golf'
        },
        {
          text: 'Hockey',
          value: 'hockey'
        },
        {
          text: 'Soccer',
          value: 'soccer'
        },
        {
          text: 'Tennis',
          value: 'tennis'
        }
      ],
      sport_filter: 'all',
      tableSort: {
        sortBy: 'created_at',
        sortOrder: 'desc',
        sortString: '-created_at',
        icon: 'mdi-sort-alphabetical-descending'
      },
      authorFilter: null,
      article_category_filter: 'dimers_content',
      article_categories: [
        {
          text: 'Dimers content',
          value: 'dimers_content'
        },
        {
          text: 'API Ingested',
          value: 'api_ingested'
        }
      ]
    }
  },

  computed: {
    ...mapState({
      articles: state => state.article.list,
      listMeta: state => state.article.listMeta,
      articleCreateAlert: state => state.article.articleCreateAlert,
      articleCreateStatus: state => state.article.articleCreateStatus
    }),

    paginationLength () {
      return (this.listMeta.total / this.listMeta.per_page) | 0
    }
  },

  methods: {
    head, // Can't be used as computed as it was used in loop
    get, // Can't be used as computed as it was used in loop,
    map,
    uniq,
    capitalize,
    ...mapActions({
      getArticles: 'article/geArticles',
      deleteArticle: 'article/deleteArticle',
      updateMainFeature: 'article/updateMainFeature',
      updateSubFeature: 'article/updateSubFeature',
      updateMoreOrderIndex: 'article/updateMoreOrderIndex',
      publishArticle: 'article/publishArticle',
      unpublishArticle: 'article/unpublishArticle',
      cloneArticle: 'article/cloneArticle'
    }),

    ...mapMutations({
      setSelectedFeaturedArticleList: 'article/setSelectedFeaturedArticleList'
    }),

    pageChanged (page) {
      this.fetchArticles(page)
    },

    search: debounce(function () {
      this.fetchArticles()
    }, 600),

    async fetchArticles (page = 1) {
      let params = { page }
      if (this.filter.search) {
        params.search = this.filter.search
      }
      params.sort = this.tableSort.sortString
      params.article_filter = this.article_filter
      params.sport_filter = this.sport_filter
      params.author_filter = this.authorFilter
      params.article_category_filter = this.article_category_filter
      this.loading = true
      await this.getArticles(params)
      this.loading = false
    },

    filterArticles: debounce(function () {
      this.resetSort()
      this.fetchArticles()
    }, 600),

    sortArticles: debounce(function () {
      this.fetchArticles()
    }, 600),

    resetFilter: debounce(function () {
      this.sport_filter = 'all'
      this.article_filter = 'all'
      this.authorFilter = null
      this.resetSort()
      this.fetchArticles()
    }, 600),

    async viewArticleDetails (id) {
      this.editArticle(id)
    },

    async setAsFeaturedArticle (articleId, orderValue) {
      this.loading = true
      if (orderValue == 1) {
        await this.updateMainFeature({
          id: articleId,
          order_index: orderValue
        }).then(() => {
          this.showSnackbar(this.articleCreateAlert)
        })
      } else {
        await this.updateSubFeature({
          id: articleId,
          order_index: orderValue
        }).then(() => {
          this.showSnackbar(this.articleCreateAlert)
        })
      }
      this.loading = false
    },

    async setAsMoreOrderIndex (articleId, orderValue) {
      this.loading = true

      await this.updateMoreOrderIndex({
        id: articleId,
        more_order_index: orderValue
      }).then(() => {
        this.showSnackbar(this.articleCreateAlert)
      })

      this.loading = false
    },

    confirmDeleModal (id, index) {
      this.confirmDeleteDialog = true
      this.toBeDeleted.id = id
      this.toBeDeleted.index = index
    },

    async removeArticle () {
      this.confirmDeleteDialog = false
      this.deleting_article = true
      let params = { id: this.toBeDeleted.id, index: this.toBeDeleted.index }

      await this.deleteArticle(params)
      this.deleting_article = false

      this.saving = false
      this.snackbar.color = this.articleCreateStatus
      this.showSnackbar(this.articleCreateAlert)
    },

    showSnackbar (message, color = 'success') {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    },

    previewArticle (article) {
      if (article.slug !== null) {
        window.open(process.env.VUE_APP_WEB_URL + '/news/preview/' + article.slug + '-' + article.id)
      } else {
        window.open(process.env.VUE_APP_WEB_URL + '/news/preview/' + article.id)
      }
    },

    editArticle (id) {
      this.$router.push({ name: 'articles.edit', params: { id } })
    },

    sortTable (sortBy) {
      if (this.tableSort.sortBy !== sortBy) {
        this.tableSort.sortBy = sortBy
        this.tableSort.sortOrder = 'asc'
        this.tableSort.sortString = sortBy
        this.tableSort.icon = 'mdi-sort-alphabetical-ascending'
      } else {
        this.tableSort.sortBy = sortBy
        if (this.tableSort.sortOrder === 'asc') {
          this.tableSort.sortOrder = 'desc'
          this.tableSort.sortString = '-' + sortBy
          this.tableSort.icon = 'mdi-sort-alphabetical-descending'
        } else {
          this.tableSort.sortOrder = 'asc'
          this.tableSort.sortString = sortBy
          this.tableSort.icon = 'mdi-sort-alphabetical-ascending'
        }
      }
      this.sortArticles()
    },

    resetSort () {
      this.tableSort.sortBy = 'created_at'
      this.tableSort.sortOrder = 'desc'
      this.tableSort.sortString = '-created_at'
      this.tableSort.icon = 'mdi-sort-alphabetical-descending'
    },

    async triggerUnpublishArticle (id) {
      this.loading = true
      let page = this.listMeta.current_page
      await this.unpublishArticle({ id: id })
      this.fetchArticles(page)
      this.loading = false

      this.snackbar.color = this.articleCreateStatus
      this.showSnackbar(this.articleCreateAlert)
    },

    async triggerPublishArticle (id) {
      this.loading = true
      await this.publishArticle({ id: id })
      let page = this.listMeta.current_page
      this.fetchArticles(page)
      this.loading = false

      this.snackbar.color = this.articleCreateStatus
      this.showSnackbar(this.articleCreateAlert)
    },

    async triggerCloneArticle (id) {
      this.loading = true

      await this.cloneArticle(id)
        .then(() => {
          this.showSnackbar(this.articleCreateAlert, this.articleCreateStatus)
          this.fetchArticles()
        })
        .finally(() => {
          this.loading = false
        })
    },

    getAuthorName(data) {
      let firstName = data.first_name || ''
      let lastName = data.last_name || ''

      let displayName = firstName + ' ' + lastName

      return displayName
    }

  },

  filters: {
    formatNumber (value) {
      return Number(value).toLocaleString()
    }
  },

  created () {
    this.fetchArticles()
  }
}
</script>

<style scoped>
tr:hover {
  cursor: pointer;
}
.hoverable:hover {
  cursor: pointer;
}
.filter-btn {
  margin-bottom: -31px;
}
.capitalize {
  text-transform: capitalize;
}
.confirm-delete {
  word-break: initial;
}
</style>
